<template>
  <div>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column prop="id" label="充值订单号" width="240px"></el-table-column>
      <el-table-column prop="price" label="充值金额（实际）"></el-table-column>
      <el-table-column prop="name" label="cdk名称"></el-table-column>
      <el-table-column prop="cdk" label="cdk" width="200px"></el-table-column>
      <!-- <el-table-column prop="pay_type" label="充值方式">
        <template slot-scope="{row}">
          <span v-if="row.pay_type === 1">支付宝</span>
          <span v-if="row.pay_type === 2">微信</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="code" label="推广码"></el-table-column> -->
      <el-table-column prop="use_time" label="使用时间"></el-table-column>
      <el-table-column prop="status" label="订单状态">
        <template slot-scope="{row}">
          <span v-if="row.status === 1">未支付</span>
          <span v-if="row.status === 2">充值成功</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="page"
      @current-change="handlePageChange"
    ></el-pagination>
  </div>
</template>

<script>
import { getData } from '../../http'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      loading: false,
      page: 1
    }
  },

  methods: {
    getTableData() {
      this.loading = true
      getData(`user_cdk/${this.id}`, { page: this.page })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.page = page
      this.getTableData()
    }
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
